
import { defineComponent, type PropType } from "vue";

export default defineComponent({
	props: {
		scrollableX: { type: Boolean as PropType<boolean>, default: false },
		scrollableY: { type: Boolean as PropType<boolean>, default: false },
	},
});
